module.exports = __webpack_public_path__ + "img/estj.71a8a91e.png";